module.exports = __webpack_public_path__ + "static/media/Scene 7.d7f7fe0b.jpg";